export default "__VITE_ASSET__qAnUkQ_V__"